import React, { Component } from "react";
import FilterMenu from "components/FilterMenu";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import FilterList from "components/FilterList";

class SegmentStep extends Component {
  render() {
    return (
      <React.Fragment>
        <FilterMenu />
        <Gap.Large vertical />
        <FilterList removable />
      </React.Fragment>
    );
  }
}
export default SegmentStep;



// WEBPACK FOOTER //
// ./src/components/SegmentStep/index.js